import { createPagination } from '@luna/api';
import type { ExportFile } from '@shared/export-center';

import { fetchMetadataExportFiles } from './fetchMetadataExportFiles';
import type { ExportFilesFilterParams } from './ExportFilesFilterParams';
import type { ExportFileMetadataAggregations } from '../types';

type AdditionalData = {
    aggregations?: ExportFileMetadataAggregations;
    totalElements: number;
};

const CACHE_DURATION_MS = 180000; // 3 minutes

export const [useMetadataExportFiles, { invalidateLists: invalidateMetadataExportFiles }] =
    createPagination<ExportFile, ExportFilesFilterParams, AdditionalData>({
        name: 'export/files/metadata',
        cacheDuration: CACHE_DURATION_MS,
        payloadCreator: async (exportFilterParams, { pageNumber: page = 0, pageSize }) => {
            const {
                page: responsePage,
                files,
                aggregations,
            } = await fetchMetadataExportFiles({
                ...exportFilterParams,
                pageSize,
                page,
            });

            const { currentPage, totalPages, totalElements } = responsePage;

            return {
                data: files,
                pageNumber: currentPage,
                pageCount: totalPages,
                additionalData: { aggregations, totalElements },
            };
        },
    });
